import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CalendarService } from './../calendar.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatInputModule } from '@angular/material';
import { Calendar } from './../calendar.model';
import { CalendarEventTypeService } from '../calendar-event-type.service';
import { CalendarEventType } from '../calendar-event-type.model';
import * as moment from 'moment-timezone';

@Component({
    selector: 'app-calendar-edit',
    templateUrl: './calendar-edit.component.html',
    styleUrls: ['./calendar-edit.component.css']
})
export class CalendarEditComponent implements OnInit {
    public calendarForm: FormGroup;
    public eventTypes: CalendarEventType[];
    public dateError: string;
    public dateErrorDescription: string;
    public isSuccess: boolean = false;
    public isFail: boolean = false;
    public calendarevent: Calendar;
    private pageNumber: number;
    private pageSize: number;
    public startTimes: any[] = [
        { name: 'All Day', value: 0},
        { name: '8:00AM', value: 8 },
        { name: '9:00AM', value: 9 },
        { name: '10:00AM', value: 10 },
        { name: '11:00AM', value: 11 },
        { name: '12:00PM (Noon)', value: 12 },
        { name: '1:00PM', value: 13 },
        { name: '2:00PM', value: 14 },
        { name: '3:00PM', value: 15 },
        { name: '4:00PM', value: 16 },
        { name: '5:00PM', value: 17 },
        { name: '6:00PM', value: 18 },
        { name: '7:00PM', value: 19 },
        { name: '8:00PM', value: 20 },
    ];
   
    constructor(
        public dialogRef: MatDialogRef<CalendarEditComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private eventService: CalendarEventTypeService,
        private calendarService: CalendarService) {
        this.calendarevent = data.calendarEvent;
        this.pageNumber = data.pageNumber;
        this.pageSize = data.pageSize;
        this.createForm();
    }

    ngOnInit() {
        this.getEvents();
    }

    getEvents() {
        this.eventService.getCalendarEventTypeCache()
            .then(resp => {
                this.eventTypes = resp;
            })
    }

    createForm() {
        this.calendarForm = this.fb.group({
            date: [null, Validators.required],
            description: [null, Validators.required],
            time: [],
            eventTypeId: [null, Validators.required]
        });

        this.calendarForm.patchValue({
            date: this.calendarevent.date,
            description: this.calendarevent.description,
            eventTypeId: this.calendarevent.eventTypeId,
            time: new Date (this.calendarevent.date).getHours(),
        });
    }

    onSubmit() {
        if (!this.calendarForm.valid) {
            this.isFail = true;
            if (this.calendarForm.value.description == "") {
                this.dateErrorDescription= "Must include description.";
            }
            return;
        }
        else {
            this.calendarevent = this.prepareSaveCalendarEvent();

            // force date to be est timezone
            var estDateTime: Date = new Date(moment.tz(this.calendarevent.date, 'America/New_York').format());
            estDateTime.setHours(parseInt(this.calendarevent.time));
            this.calendarevent.date = estDateTime;

            this.calendarService.updateCalendarEvent(this.calendarevent.id, this.calendarevent)
                .then((result) => {
                    this.calendarService.getCalendarEvents(this.pageNumber, this.pageSize, false);
                    this.dialogRef.close(result);                   
                })
                .catch(error => console.log(error));
        }
       
    }

    prepareSaveCalendarEvent(): Calendar {
        const formModel = this.calendarForm.value;
        const saveCalendar: Calendar = {
            id: this.calendarevent.id,
            date: formModel.date as Date,
            description: formModel.description as string,
            time: formModel.time as string,
            eventTypeId: formModel.eventTypeId as number,
            eventName: formModel.eventName as string
        }
        return saveCalendar;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar-edit/calendar-edit.component.ts